import { Injector } from '@angular/core';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  AccountInfoType,
  ActionButtonOutcomesType,
  BaseWidgetProperties,
} from '@finxone-platform/shared/sys-config-types';
import { Actions, Store, ofActionDispatched } from '@ngxs/store';
import { filter, map, take } from 'rxjs';
import { UpdateFormDataActionWithId } from '../../../actions/form-submission.action';
import { InternationalCreatePayment } from '../../../actions/payment.action';
import { TransferMoneyRequest } from '../../../services/account-service/account.type';
import { AccountState } from '../../../state/account.state';
import { FormActionState, FormDataType } from '../../../state/form-submision.state';
import { handleRedirection } from '../cta-redirection.utils';

export function internationPaymentPrecheck(widgetProperties: BaseWidgetProperties, injector: Injector) {
  const store = injector.get(Store);
  const actions = injector.get(Actions);
  const accountsData = store.selectSnapshot(AccountState.getAccounts).accounts;
  const activeAccountId = store.selectSnapshot(AccountState.getCurrentAccountId);
  intiateDryRunTransaction(store, activeAccountId);
  actions
    .pipe(
      ofActionDispatched(UpdateFormDataActionWithId),
      filter((action) => action.id === FormActionTypeEnum.INTL_TRANSFER_RESPONSE),
      take(1),
      map((action) => {
        if (action.formData?.['totalAmount']) {
          checkBalanceAndRedirect(action.formData, injector, activeAccountId, accountsData, widgetProperties);
        }
      }),
    )
    .subscribe();
}

function intiateDryRunTransaction(store: Store, activeAccountId: string) {
  let formStateData: TransferMoneyRequest =
    store.selectSnapshot(FormActionState.getFormActionState).response?.formData ?? {};
  formStateData = {
    ...formStateData,
    review: true,
    sourceAccountId: activeAccountId,
  };
  store.dispatch(new InternationalCreatePayment(formStateData));
}

function checkBalanceAndRedirect(
  formData: FormDataType,
  injector: Injector,
  activeAccountId: string,
  accountsData: AccountInfoType[],
  widgetProperties: BaseWidgetProperties,
) {
  const alertHandlerService = injector.get(AlertHandlerService);
  if (!formData || !accountsData) {
    throw new Error('formData or accountsData is undefined or null');
  }

  const account = accountsData.find((account) => account.accountId === activeAccountId);
  if (!account) {
    throw new Error('Account with activeAccountId not found');
  }

  const amountPlusFees = Number(formData?.['totalAmount'] || formData?.['amount']);
  const accountBalance = Number(account.balance);
  if (isNaN(accountBalance) || isNaN(amountPlusFees)) {
    throw new Error('Account balance or payment amount is NaN');
  }

  const isBalanceAvailable = accountBalance >= amountPlusFees;

  if (isBalanceAvailable) {
    handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.SUCCESS);
  } else {
    alertHandlerService.showAlertFn('error', 'Enter a lower amount to continue.', 'Insufficient balance.');
  }
}
